import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=3fe1eba9&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=3fe1eba9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe1eba9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe1eba9')) {
      api.createRecord('3fe1eba9', component.options)
    } else {
      api.reload('3fe1eba9', component.options)
    }
    module.hot.accept("./TermsOfService.vue?vue&type=template&id=3fe1eba9&scoped=true", function () {
      api.rerender('3fe1eba9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Informational/TermsOfService.vue"
export default component.exports